module.exports = __webpack_public_path__ + "static/pwb2-e377f13b7c112e7fc65adbb8569347ec.jpg";